//
// App.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React, { PureComponent } from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Content from './components/Content'
import Header from './components/Header'
import Footer from './components/Footer'

import HomePage from './pages/HomePage'
import SearchPage from './pages/SearchPage'
import ContentPage from './pages/ContentPage'

import {cleanSpecial, cleanAccent } from './tools/utils'

const NoMatch = ({ location }) => (
    <div>
        <Header content={"Not Found"} />
        <Content name='Search' content={"Not Found [" + cleanAccent(cleanSpecial(location.pathname)) + "]"} />
        <Footer />
    </div>
);

export default class App extends PureComponent {
 
    render() {
        return (
            <BrowserRouter>
                <div>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route index element={<HomePage />} />
                        <Route path="/search/:name" element={<SearchPage />} />
                        <Route path="/content/:name" element={<ContentPage />} />
                        <Route path="*" element={<NoMatch />} />
                    </Routes>
                </div>
            </BrowserRouter>
        )
    }
}
